<template>
  <div style="float: left;margin-top: 10px;">
    <div class="m-form__group m-form__group--inline">
      <div class="m-form__label">
        <label style="width: 100px;text-align:right;">{{label}}：</label>
      </div>
      <div class="m-form__control">
        <el-input :placeholder="displaytext" v-model="input" clearable @change="currentSel"></el-input>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchNormalText',
  data () {
    return {
      input: ''
    }
  },
  props: {
    label: {
      type: String
    },
    value: {
      type: String
    },
    displaytext: {
      type: String,
      default: ''
      // require: true // 必填
    }
  },
  methods: {
    currentSel: function (selVal) {
      this.$emit('input', selVal)
    }
  },
  watch: {
    value (nv) {
      this.input = nv
    }
  },
  mounted: function () {
    this.input = this.value
  }
}
</script>

<style scoped="scoped">
  .el-input__inner {
    width:100%;
    padding-left: 19px;
  }
</style>
